import React from 'react';
import SponsorsLottie from '../SponsorsLottie';

export default function SponsorHero() {
  return (
    <div className="bg-primary text-white py-8">
      <div className="container mx-auto px-4 text-center">
        <SponsorsLottie className="mb-2" />
        <h1 className="text-4xl md:text-5xl font-bold mb-4">Patrocinador Oficial</h1>
        <p className="text-xl text-gray-200 max-w-2xl mx-auto">
          Haciendo realidad la magia de la Navidad junto a TodoJuguete
        </p>
      </div>
    </div>
  );
}